<div class="external-link">
  <span class="link-content">
    <a
      class="text-link"
      target="_blank"
      rel="noopener noreferrer"
      matTooltip="Open link in new tab"
      [href]="normalizedUrl() ?? '' | url"
    >
      <ng-content />
    </a>
  </span>

  @if (hasUrl()) {
    <procure-copy-button
      tooltip="Copy link"
      [value]="normalizedUrl()"
    />
  }
</div>
